import React, { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import AuthUserDropdown from "../../../../shared/widgets/AuthUserDropdown";
import SearchGlobal from "../../../../shared/SearchGlobal";
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  Switch,
  TextField,
  Typography,
  useMediaQuery,
  Divider,
  Radio,
  RadioGroup,
} from "@mui/material";
import Div from "@jumbo/shared/Div";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import JumboIconButton from "@jumbo/components/JumboIconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Logo from "../../../../shared/Logo";
import { SIDEBAR_STYLES, SIDEBAR_VARIANTS } from "@jumbo/utils/constants";
import useJumboHeaderTheme from "@jumbo/hooks/useJumboHeaderTheme";
import HomeIcon from "@mui/icons-material/Home";
import Avatar from "@mui/material/Avatar";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Modal from "@mui/material/Modal";
import SettingsIcon from "@mui/icons-material/Settings";
import Button from "@mui/material/Button";
import TenantUsersList from "app/pages/tenants/TenantUsersList";
import TrexoBreadCrumb from "app/components/trexoBreadcrumb";
import { axios_tenant } from "../../../../../axios";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { getTenantName, isCrowellTenant } from "../../../../utils/tenantUtils";
import HelpDropdown from "app/components/HelpDropDown";
import {
  sortIntentsByCategory,
  getAllIpAppIds,
  addIpAppIds,
  removeIpAppIds,
  toggleIpAppIds,
  getAppIntentSelectionState
} from "app/utils/intentUtils";

const oaWorkflowTenants = (process.env.REACT_APP_INTERNAL_TENANTS || "trexo-ops")
    .split(",").map(t => t.trim().toLowerCase());
const isOaWorkflowTenant = oaWorkflowTenants.includes(getTenantName()?.toLowerCase());

const isKotApp = (appName = "") =>
  appName.toUpperCase().includes("KOT") ||
  appName.toUpperCase().includes("KEEP ON TOP");

const Header = () => {
  const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar({ open: false });
  const [dropdownSearchVisibility, setDropdownSearchVisibility] = useState(false);
  const { headerTheme } = useJumboHeaderTheme();
  const [openAdd, setOpenAdd] = useState(false);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [inviteRole, setInviteRole] = useState("");
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState({ active: true, deactivated: true, pending: true });
  const { active, deactivated, pending } = checked;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [appToggle, setAppToggle] = useState({});

  const [selectedInviteApps, setSelectedInviteApps] = useState([]);
  const [selectedIpApps, setSelectedIpApps] = useState([]);
  const [oaShellAccess, setOaShellAccess] = useState(false);
  const [oaRole, setOaRole] = useState("");
  const [pgsAccess, setPgsAccess] = useState(false);
  const [pgsRole, setPgsRole] = useState("");

  // KOT State
  const [availableKotRoles, setAvailableKotRoles] = useState([]);
  const [kotRole, setKotRole] = useState("");
  const [fetchingKotRoles, setFetchingKotRoles] = useState(false);
  const [allApps, setAllApps] = useState([]);
  const [searchFilter, setSearchFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const showDropdownSearch = useMediaQuery("(max-width:575px)");

  let dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const role = localStorage.getItem("TENANT_ROLE");

  const idpToken = Cookies.get("idpToken");
  const decodedToken = idpToken && jwtDecode(idpToken);
  const isIdpEnabled = decodedToken && decodedToken?.isIdpEnabled;

  useEffect(() => {
    location.pathname.includes("dashboard") && setSidebarOptions({ open: false });
  }, []);

  useEffect(() => {
    if (location.pathname.includes("dashboard") || location.pathname.includes("trexo-chat") || location.pathname.includes("trademark-search") || location.pathname.includes("data-verification")) {
      setSidebarOptions({ open: false });
    } else {
      setSidebarOptions({ open: true });
    }
  }, [location.pathname]);

  const handleHomeClick = () => {
    if (location.pathname.startsWith("/superadmin")) navigate("/superadmin/apps");
    else navigate("/dashboard");
  };

  const handleChange = (e) => {
    dispatch({
      type: "SEARCH_QUERY",
      payload: { text: e.target.value },
    });
  };

  const handleSidebarClick = () => {
    !location.pathname.includes("dashboard") && setSidebarOptions({ open: !sidebarOptions.open });
  };

  const style = {
    height: "80%",
    maxHeight: "80vh",
    overflowY: "auto",
  };

  const styleInvite = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    maxHeight: "80vh",
    width: "60%",
    overflowY: "auto",
  };

  const styleOuter = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "70%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    maxHeight: "80vh",
  };

  const handleModalClick = () => {
    setOpenAdd(!openAdd);

    if (openAdd) {
      setSearchQuery("");
      setSearchFilter("all");
    }

    axios_tenant
      .get("/apps/activeApps")
      .then((res) => setAllApps(res.data))
      .catch((err) => console.error(err));
  };


  const fetchKotRoles = async () => {
    try {
      setFetchingKotRoles(true);
      const res = await axios_tenant.get("/kot/admin/roles");
      if (res.data) {
        setAvailableKotRoles(res.data.filter(role => role.kotRoleId !== "ADMIN"));
      }
    } catch (e) {
      console.error("Failed to fetch KOT roles", e);
    } finally {
      setFetchingKotRoles(false);
    }
  };

  const handleAppToggle = (appName) => {
    setAppToggle(prev => {
      const newToggle = { ...prev, [appName]: !prev[appName] };

      if (isKotApp(appName) && inviteRole !== 'admin') {
        if (newToggle[appName] && availableKotRoles.length === 0) {
          fetchKotRoles();
        }
        setKotRole("");
      }

      const app = allApps.find(a => a.app_name === appName);
      const appIpAppIds = getAllIpAppIds(app);

      if (newToggle[appName]) {
        setSelectedInviteApps(prev => [...new Set([...prev, appName])]);
        setSelectedIpApps(prev => addIpAppIds(prev, appIpAppIds));
      } else {
        setSelectedInviteApps(prev => prev.filter(name => name !== appName));
        setSelectedIpApps(prev => removeIpAppIds(prev, appIpAppIds));
      }

      return newToggle;
    });
  };

  const handleAppIntentsToggle = (appIpAppIds, isCurrentlyChecked) => {
    setSelectedIpApps(prev => toggleIpAppIds(prev, appIpAppIds, isCurrentlyChecked));
  };

  const handleCategoryToggle = (categoryIpAppIds, isCurrentlyChecked) => {
    setSelectedIpApps(prev => {
      if (isCurrentlyChecked) {
        return prev.filter(id => !categoryIpAppIds.includes(id));
      } else {
        const newSelected = [...new Set([...prev, ...categoryIpAppIds])];
        return newSelected;
      }
    });
  };

  const handleIntentSelection = (ipAppId) => {
    setSelectedIpApps(prev => {
      if (prev.includes(ipAppId)) {
        return prev.filter(id => id !== ipAppId);
      } else {
        return [...prev, ipAppId];
      }
    });
  };

  const handleInvite = (e) => {
    e.preventDefault();
    setLoading(true);
    setOpen(false);

    let inviteEmail;
    if (email.includes(",")) {
      inviteEmail = email.split(",")[0];
    } else if (email.includes(";")) {
      inviteEmail = email.split(";")[0];
    } else {
      inviteEmail = email;
    }

    const payload = {
      email: inviteEmail?.trim(),
      role: inviteRole,
      apps: selectedInviteApps,
      ip_apps: selectedIpApps,
      firstName,
      lastName,
      ...(oaRole && { oaRole }),
      ...(pgsRole && { pgsRole }),
      ...(selectedInviteApps.includes("KOT") && { kotRole: inviteRole === "admin" ? "ADMIN" : kotRole }),
    };

    axios_tenant
      .post("/user/sendInvitation", payload)
      .then((res) => {
        setLoading(false);
        if (isIdpEnabled) {
          toast.success(res.data.message);
        } else {
          toast.success(`Invite link sent to ${inviteEmail}`);
        }
        // Reset form
        setEmail("");
        setInviteRole("");
        setFirstName("");
        setLastName("");
        setSelectedInviteApps([]);
        setSelectedIpApps([]);
        setAppToggle({});
        setOaShellAccess(false);
        setOaRole("");
        setPgsAccess(false);
        setPgsRole("");
        setKotRole("");
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleClose = () => {
    setOpen(false);
    // Reset form state
    setEmail("");
    setInviteRole("");
    setFirstName("");
    setLastName("");
    setSelectedInviteApps([]);
    setSelectedIpApps([]);
    setAppToggle({});
    setOaShellAccess(false);
    setOaRole("");
    setPgsAccess(false);
    setPgsRole("");
    setKotRole("");
  };

  const handleClick = () => setOpen(!open);

  return (
    <React.Fragment>
      {(sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER ||
        sidebarOptions.variant === SIDEBAR_VARIANTS.TEMPORARY ||
        (sidebarOptions.variant === SIDEBAR_VARIANTS.PERSISTENT && !sidebarOptions.open)) &&
        !(location.pathname.includes("dashboard") || location.pathname.includes("trexo-chat")) && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{
              ml: sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER ? -2 : 0,
              mr: 3,
            }}
            onClick={handleSidebarClick}
          >
            {sidebarOptions?.open ? <MenuOpenIcon /> : <MenuIcon />}
          </IconButton>
        )}
      {sidebarOptions?.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER && (
        <Logo sx={{ mr: 3 }} mode={headerTheme.type ?? "light"} />
      )}

      {showDropdownSearch && (
        <Slide in={dropdownSearchVisibility}>
          <Div
            sx={{
              zIndex: 5,
              left: 0,
              right: 0,
              position: "absolute",
              height: "100%",
            }}
          >
            <TrexoBreadCrumb />

            <SearchGlobal
              sx={{
                maxWidth: "none",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                "& .MuiInputBase-root": {
                  flex: 1,
                  borderRadius: 0,
                  background: (theme) => theme.palette.background.default,
                },
                "& .MuiInputBase-input": {
                  pr: 6,
                },
              }}
            />
            <IconButton
              sx={{
                position: "absolute",
                right: 15,
                top: "50%",
                color: "inherit",
                transform: "translateY(-50%)",
              }}
              onClick={() => setDropdownSearchVisibility(false)}
            >
              <CloseIcon />
            </IconButton>
          </Div>
        </Slide>
      )}

      {!location.pathname.includes("superadmin") && <TrexoBreadCrumb />}

      <Stack direction="row" alignItems="center" spacing={0.15} sx={{ ml: "auto" }}></Stack>

      {!showDropdownSearch &&
        (location.pathname.includes("superadmin") && (
          <SearchGlobal
            sx={{
              maxWidth: { xs: 240, md: 320 },
            }}
            handleChange={handleChange}
          />
        ))}

      <Stack direction="row" alignItems="center" spacing={1.25} sx={{ ml: "auto" }}>
        {showDropdownSearch && (
          <JumboIconButton elevation={25} onClick={() => setDropdownSearchVisibility(true)}>
            <SearchIcon fontSize={"small"} />
          </JumboIconButton>
        )}

        {
          (location.pathname.includes("trexo-chat") || location.pathname.includes("docgen") || location.pathname.includes("drm")) &&
          <HelpDropdown />
        }

        {!location.pathname.includes("dashboard") && (
          <Avatar
            sx={{
              width: "40px",
              height: "40px",
              backgroundColor: "#ced4da",
            }}
            onClick={handleHomeClick}
          >
            <HomeIcon style={{ fontSize: "32px", cursor: "pointer" }} />
          </Avatar>
        )}

        {(!location.pathname.startsWith("/superadmin") && !isCrowellTenant() && role === "admin") && (
          <Avatar
            sx={{
              width: "40px",
              height: "40px",
              backgroundColor: "#ced4da",
            }}
            onClick={handleModalClick}
          >
            <SettingsIcon style={{ fontSize: "32px", cursor: "pointer" }} />
          </Avatar>
        )}

        <Modal
          open={openAdd}
          onClose={() => {
            setOpenAdd(false);
            setSearchQuery("");
            setSearchFilter("all");
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Div sx={styleOuter}>
            <Box sx={{ display: "flex", mt: "1%", alignItems: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #ccc",
                  borderRadius: "25px",
                  overflow: "hidden",
                  height: 40,
                  width: 320,
                }}
              >
                <FormControl
                  size="small"
                  sx={{
                    minWidth: 100,
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                  }}
                >
                  <Select
                    value={searchFilter}
                    onChange={(e) => setSearchFilter(e.target.value)}
                    displayEmpty
                    sx={{
                      borderRight: "1px solid #ccc",
                      borderRadius: 0,
                      height: 40,
                      pl: 1.5,
                    }}
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="users">Users</MenuItem>
                    <MenuItem value="role">Role</MenuItem>
                    <MenuItem value="email">Email</MenuItem>
                    <MenuItem value="status">Status</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  size="small"
                  variant="outlined"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  sx={{
                    flex: 1,
                    "& .MuiOutlinedInput-root": {
                      border: "none",
                      height: 40,
                      "& fieldset": { border: "none" },
                    },
                    "& .MuiInputBase-input": {
                      color: "#000",
                      fontSize: "0.9rem",
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#000",
                      opacity: 0.8,
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <IconButton onClick={() => console.log("Searching for:", searchQuery)}>
                        <SearchIcon sx={{ color: "#666" }} />
                      </IconButton>
                    ),
                  }}
                />
              </Box>

              <Box sx={{ flexGrow: 1 }} />

              <Button
                variant="contained"
                color="primary"
                style={{ marginBottom: "2%", marginRight: "1%" }}
                onClick={() => {
                  setOpenAdd(false);
                  setSearchQuery("");
                  setSearchFilter("all");
                }}
              >
                Close
              </Button>

              <Button variant="contained" color="primary" style={{ marginBottom: "2%" }} onClick={handleClick} disabled={loading}>
                {loading ? <CircularProgress sx={{ color: "blue" }} /> : <span>Invite Users</span>}
              </Button>
            </Box>

            {isIdpEnabled ? (
              <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Div sx={styleInvite}>
                  <Typography id="modal-modal-title" variant="h4" component="h2">
                    <TextField label="First Name" value={firstName} variant="outlined" fullWidth onChange={(e) => setFirstName(e.target.value.toLowerCase())} />
                  </Typography>
                  <Typography id="modal-modal-title" variant="h4" component="h2">
                    <TextField label="Last Name" value={lastName} variant="outlined" fullWidth onChange={(e) => setLastName(e.target.value.toLowerCase())} />
                  </Typography>
                  <Typography id="modal-modal-title" variant="h4" component="h2">
                    <TextField label="Email" value={email} variant="outlined" fullWidth onChange={(e) => setEmail(e.target.value.toLowerCase())} />
                  </Typography>

                  <Typography id="modal-modal-title" variant="h4" component="h2" sx={{ mb: 3 }}>
                    <FormControl fullWidth>
                      <InputLabel>Role</InputLabel>
                      <Select value={inviteRole} onChange={(e) => setInviteRole(e.target.value)} label="Select Option">
                        <MenuItem value="admin">Admin</MenuItem>
                        <MenuItem value="user">User</MenuItem>
                      </Select>
                    </FormControl>
                  </Typography>

                  <Typography variant="h6" sx={{ mt: 2 }}>
                    Authorized Apps
                  </Typography>
                  <Box
                    sx={{
                      ml: 2,
                      maxHeight: 200,
                      overflowY: "auto",
                      border: "1px solid #eee",
                      p: 1,
                      borderRadius: 1,
                    }}
                  >
                    <FormGroup>
                      {allApps.map((app) => {
                        if (app.TenantAppMapping.isactive) {
                          return (
                            <Box key={app.app_id}>
                              <FormControlLabel control={<Checkbox checked={selectedInviteApps.includes(app.app_name)} onChange={() => handleAppToggle(app.app_name)} color="primary" />} label={app.app_name} />
                              {app.app_name === "COLLABORATE" && selectedInviteApps.includes("COLLABORATE") && inviteRole !== "admin" && isOaWorkflowTenant && (
                                <Box sx={{ ml: 4, mb: 1, p: 1, border: "1px dashed #ccc", borderRadius: 1 }}>
                                  <Box sx={{ mb: 1 }}>
                                    <FormControlLabel
                                      control={<Checkbox size="small" checked={oaShellAccess} onChange={(e) => {
                                        setOaShellAccess(e.target.checked);
                                        if (e.target.checked) setOaRole("Application Manager");
                                        else setOaRole("");
                                      }} />}
                                      label={<Typography variant="body2" fontWeight="600">OA Shell Workflow</Typography>}
                                    />
                                    {oaShellAccess && (
                                      <Box sx={{ ml: 4, mt: 0.5, mb: 1 }}>
                                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>Select Role:</Typography>
                                        <RadioGroup row value={oaRole} onChange={(e) => setOaRole(e.target.value)}>
                                          <FormControlLabel value="Application Manager" control={<Radio size="small" />} label="Application Manager" />
                                          <FormControlLabel value="Processor" control={<Radio size="small" />} label="Processor" />
                                          <FormControlLabel value="QA" control={<Radio size="small" />} label="QA" />
                                        </RadioGroup>
                                      </Box>
                                    )}
                                  </Box>
                                  <Box sx={{ mt: 1 }}>
                                    <FormControlLabel
                                      control={<Checkbox size="small" checked={pgsAccess} onChange={(e) => {
                                        setPgsAccess(e.target.checked);
                                        if (e.target.checked) setPgsRole("Application Manager");
                                        else setPgsRole("");
                                      }} />}
                                      label={<Typography variant="body2" fontWeight="600">Post Grant Support Workflow</Typography>}
                                    />
                                    {pgsAccess && (
                                      <Box sx={{ ml: 4, mt: 0.5 }}>
                                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>Select Role:</Typography>
                                        <RadioGroup row value={pgsRole} onChange={(e) => setPgsRole(e.target.value)}>
                                          <FormControlLabel value="Application Manager" control={<Radio size="small" />} label="Application Manager" />
                                          <FormControlLabel value="Processor" control={<Radio size="small" />} label="Processor" />
                                          <FormControlLabel value="QA" control={<Radio size="small" />} label="QA" />
                                        </RadioGroup>
                                      </Box>
                                    )}
                                  </Box>
                                </Box>
                              )}
                              {inviteRole !== 'admin' && isKotApp(app.app_name) && selectedInviteApps.includes(app.app_name) && (
                                <Box sx={{ ml: 4, mb: 1, p: 1, border: "1px dashed #ccc", borderRadius: 1 }}>
                                  <Typography variant="body2" fontWeight="600" sx={{ mb: 0.5 }}>KOT Roles</Typography>
                                  {fetchingKotRoles ? (
                                    <CircularProgress size={20} />
                                  ) : (
                                    <Box display={"flex"}>
                                      <RadioGroup row value={kotRole || ""} onChange={(e) => setKotRole(e.target.value)}>
                                        {availableKotRoles.map((kRole) => (
                                          <FormControlLabel key={kRole.kotRoleId} value={kRole.kotRoleId} control={<Radio size="small" />} label={kRole.name} />
                                        ))}
                                      </RadioGroup>
                                      {availableKotRoles.length === 0 && (
                                        <Typography variant="body2" color="textSecondary">No roles available</Typography>
                                      )}
                                    </Box>
                                  )}
                                </Box>
                              )}
                            </Box>
                          );
                        }
                        return null;
                      })}
                    </FormGroup>
                  </Box>

                  <Box textAlign="right" sx={{ mt: 2 }}>
                    <Button type="submit" variant="contained" color="primary" onClick={handleInvite} disabled={!(inviteRole && email && firstName && lastName)}>
                      Send Invite
                    </Button>
                  </Box>
                </Div>
              </Modal>
            ) : (
              <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Div sx={styleInvite}>
                  <Typography id="modal-modal-title" variant="h4" component="h2" sx={{ mt: 3 }}>
                    <TextField
                      label="Email"
                      value={email}
                      variant="outlined"
                      fullWidth
                      onChange={(e) => setEmail(e.target.value.toLowerCase())}
                    />
                  </Typography>

                  <Typography id="modal-modal-title" variant="h4" component="h2" sx={{ mb: 3 }}>
                    <FormControl fullWidth>
                      <InputLabel>Role</InputLabel>
                      <Select value={inviteRole} onChange={(e) => setInviteRole(e.target.value)} label="Select Option">
                        <MenuItem value="admin">Admin</MenuItem>
                        <MenuItem value="user">User</MenuItem>
                      </Select>
                    </FormControl>
                  </Typography>

                  <Typography variant="h6" sx={{ mt: 2 }}>
                    Authorized Apps
                  </Typography>

                  <Box sx={{ maxHeight: 250, overflowY: "auto", border: "1px solid #eee", p: 1, borderRadius: 1 }}>
                    {allApps.map(app => {
                      if (!app.TenantAppMapping.isactive) return null;

                      const { appIpAppIds, areAllAppIntentsChecked, areSomeAppIntentsChecked } =
                        getAppIntentSelectionState(app, selectedIpApps);

                      return (
                        <Box key={app.app_id} sx={{ mb: 2 }}>
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              {appToggle[app.app_name] && appIpAppIds.length > 0 && (
                                <Checkbox
                                  checked={areAllAppIntentsChecked}
                                  indeterminate={areSomeAppIntentsChecked}
                                  onChange={() => handleAppIntentsToggle(appIpAppIds, areAllAppIntentsChecked)}
                                  sx={{ mr: 0.5 }}
                                />
                              )}
                              <Typography sx={{ fontSize: 16, fontWeight: 600 }}>{app.app_name}</Typography>
                            </Box>
                            <Switch
                              checked={appToggle[app.app_name] || false}
                              onChange={() => handleAppToggle(app.app_name)}
                            />
                          </Box>

                          {/* OA Shell + Post Grant Support Access Checkbox + Role Picker — hidden for admins and non-internal tenants */}
                          {app.app_name === "COLLABORATE" && appToggle["COLLABORATE"] && inviteRole !== "admin" && isOaWorkflowTenant && (
                            <Box sx={{ ml: 2, mb: 2, p: 1.5, border: "1px dashed #ccc", borderRadius: 1, backgroundColor: "#fafafa" }}>
                              <Box sx={{ mb: 2 }}>
                                <FormControlLabel
                                  control={<Checkbox size="small" checked={oaShellAccess} onChange={(e) => {
                                    setOaShellAccess(e.target.checked);
                                    if (e.target.checked) setOaRole("Application Manager");
                                    else setOaRole("");
                                  }} />}
                                  label={<Typography variant="body2" fontWeight="600">OA Shell Workflow</Typography>}
                                />
                                {oaShellAccess && (
                                  <Box sx={{ ml: 4, mt: 1 }}>
                                    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>Select Role:</Typography>
                                    <RadioGroup row value={oaRole} onChange={(e) => setOaRole(e.target.value)}>
                                      <FormControlLabel value="Application Manager" control={<Radio size="small" />} label={
                                        <Typography variant="body2">Application Manager</Typography>
                                      } />
                                      <FormControlLabel value="Processor" control={<Radio size="small" />} label={
                                        <Typography variant="body2">Processor</Typography>
                                      } />
                                      <FormControlLabel value="QA" control={<Radio size="small" />} label={
                                        <Typography variant="body2">QA</Typography>
                                      } />
                                    </RadioGroup>
                                  </Box>
                                )}
                              </Box>
                              <Box>
                                <FormControlLabel
                                  control={<Checkbox size="small" checked={pgsAccess} onChange={(e) => {
                                    setPgsAccess(e.target.checked);
                                    if (e.target.checked) setPgsRole("Application Manager");
                                    else setPgsRole("");
                                  }} />}
                                  label={<Typography variant="body2" fontWeight="600">Post Grant Support Workflow</Typography>}
                                />
                                {pgsAccess && (
                                  <Box sx={{ ml: 4, mt: 1 }}>
                                    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>Select Role:</Typography>
                                    <RadioGroup row value={pgsRole} onChange={(e) => setPgsRole(e.target.value)}>
                                      <FormControlLabel value="Application Manager" control={<Radio size="small" />} label={
                                        <Typography variant="body2">Application Manager</Typography>
                                      } />
                                      <FormControlLabel value="Processor" control={<Radio size="small" />} label={
                                        <Typography variant="body2">Processor</Typography>
                                      } />
                                      <FormControlLabel value="QA" control={<Radio size="small" />} label={
                                        <Typography variant="body2">QA</Typography>
                                      } />
                                    </RadioGroup>
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          )}

                          {appToggle[app.app_name] && app.ipApps && (
                            <Box sx={{ ml: 1 }}>
                              {Object.entries(app.ipApps).map(([category, items], index, array) => {
                                const isArray = Array.isArray(items);
                                const itemArray = isArray ? sortIntentsByCategory(category, items) : [items];
                                const categoryIds = itemArray.map(item => item.ip_app_id);
                                const checkedCount = categoryIds.filter(id => selectedIpApps.includes(id)).length;
                                const isCategoryChecked = checkedCount === categoryIds.length && categoryIds.length > 0;
                                const isIndeterminate = checkedCount > 0 && checkedCount < categoryIds.length;
                                if (categoryIds.length === 0) return null;

                                return (
                                  <Box key={category} sx={{ mt: 1 }}>
                                    {/* Category Checkbox with Indeterminate Support */}
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={isCategoryChecked}
                                          indeterminate={isIndeterminate}
                                          onChange={() => handleCategoryToggle(categoryIds, isCategoryChecked)}
                                          sx={{ mr: 1 }}
                                        />
                                      }
                                      label={<Typography sx={{ fontWeight: 600, fontSize: 14 }}>{category}</Typography>}
                                      sx={{ mb: 1 }}
                                    />

                                    {/* Individual Items */}
                                    {
                                      isArray && (
                                        <Box sx={{ ml: 2 }}>
                                          {itemArray.map(item => (
                                            <FormControlLabel
                                              key={item.ip_app_id}
                                              control={
                                                <Checkbox
                                                  checked={selectedIpApps.includes(item.ip_app_id)}
                                                  onChange={() => handleIntentSelection(item.ip_app_id)}
                                                />
                                              }
                                              label={item.subtask_name}
                                            />
                                          ))}
                                        </Box>
                                      )
                                    }
                                    {index < array.length - 1 && (
                                      <Divider sx={{ my: 2, mx: -2, backgroundColor: "#475259", border: '1px solid' }} />
                                    )}
                                  </Box>
                                );
                              })}
                            </Box>
                          )}

                          {/* KOT ROLES UI */}
                          {inviteRole !== 'admin' && appToggle[app.app_name] && isKotApp(app.app_name) && (
                            <Box sx={{ ml: 2, mt: 1 }}>
                              <Typography sx={{ fontWeight: 600, fontSize: 14, mb: 1 }}>
                                KOT Roles
                              </Typography>

                              {fetchingKotRoles ? (
                                <CircularProgress size={20} />
                              ) : (
                                <Box sx={{ ml: 1 }} display={"flex"}>
                                  <RadioGroup
                                    value={kotRole || ""}
                                    onChange={(e) => setKotRole(e.target.value)}
                                    row
                                  >
                                    {availableKotRoles.map((kRole) => (
                                      <FormControlLabel
                                        key={kRole.kotRoleId}
                                        value={kRole.kotRoleId}
                                        control={<Radio />}
                                        label={kRole.name}
                                      />
                                    ))}
                                  </RadioGroup>

                                  {availableKotRoles.length === 0 && (
                                    <Typography variant="body2" color="textSecondary">
                                      No roles available
                                    </Typography>
                                  )}
                                </Box>
                              )}
                              <Divider sx={{ my: 2, mx: -2, backgroundColor: "#475259", border: '1px solid' }} />
                            </Box>
                          )}
                        </Box>
                      );
                    })}
                  </Box>

                  <Box textAlign="right" sx={{ mt: 2 }}>
                    <Button type="submit" variant="contained" color="primary" onClick={handleInvite} disabled={!(inviteRole && email)}>
                      Send Invite
                    </Button>
                  </Box>
                </Div>
              </Modal>
            )}

            <Div sx={style}>
              <TenantUsersList checked={checked} loading={loading} searchFilter={searchFilter} searchQuery={searchQuery} />
            </Div>
          </Div>
        </Modal>

        <AuthUserDropdown />
      </Stack>
    </React.Fragment>
  );
};

export default Header;